import * as React from 'react';
import './DeliveryProduct.less';

class DeliveryProduct extends React.Component<any, any> {
    static defaultProps = {
        prefixCls: 'delivery'
    };

    render() {
        const {prefixCls, data, onCloseDelivery, onDeliveryPay, price = 0} = this.props;
        return (
            <div className={`${prefixCls}-cover`}>
                <div className={`${prefixCls}-container`}>
                    <div className={`${prefixCls}-msg`}>抱歉，您本单购买的以下商品暂不支持配送！</div>
                    <div className={`${prefixCls}-context`}>
                        {
                            data.map((item: any) => {
                                return (
                                    <div className={`${prefixCls}-context-item`} key={item.skuId}>
                                        <div className={`${prefixCls}-context-image`}>
                                            <img src={item.images} alt=""/>
                                            <div>暂不配送</div>
                                        </div>
                                        <div className={`${prefixCls}-context-title`}>{item.name}</div>
                                    </div>
                                )
                            })
                        }
                    </div>
                    <div className={`${prefixCls}-btn`}>
                        <div className={`${prefixCls}-btn-left`} onClick={onCloseDelivery}>我再想想</div>
                        <div className={`${prefixCls}-btn-right`} onClick={onDeliveryPay}>结算可配送商品(￥{price.toFixed(2)})</div>
                    </div>
                </div>
            </div>
        )
    }
}

export default DeliveryProduct


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/widgets/deliveryProduct/DeliveryProduct.tsx